// src/features/owner/sections/system/ApiIntegrationsSection.tsx — prototype keys/webhooks.
import { useOwnerAction } from '@/hooks/useOwnerAction';
import { Button } from '@/ui';
import { OwnerPanel, EmptyState } from '../../components';

export function ApiIntegrationsSection() {
  const action = useOwnerAction();
  return (
    <OwnerPanel
      title="API & Integrations (prototype, not yet wired)"
      action={
        <Button variant="primary" onClick={() => action.logAction('create-api-key', 'system')}>
          Create key
        </Button>
      }
    >
      <EmptyState icon="key" message="No API keys or webhooks yet" />
    </OwnerPanel>
  );
}
